import{ FiEdit } from'react-icons/fi'
import { aboutlist } from './mock';

export const About = () => {

    return (<div className="about">
            <div className="heading">
                <h4>About</h4>
                <div><FiEdit /></div>
            </div>
            <ul>
                {
                    aboutlist.map((item,i)=>{
                        return (
                            <li key={'about'+i}>
                                    <div className="symbol">{item.symbol}</div>
                                    <div>
                                        <h3 className="title">{item.title}</h3>
                                        <p className="description">{item.description}</p>
                                    </div>
                                </li>
                            
                            )
                        })
                    }
                </ul>


                
        </div>)
}
